import Royal2 from "../../../../src/components/RenderImgs/royalcanin2Imgs";
import * as React from 'react';
export default {
  Royal2,
  React
};